import React from "react";
import { LoginAFY } from "@affinitysystemsgroup/github-packages-affinity-components/dist";

export const View = ({ ...props }) => {
  return (
    <LoginAFY
      title={props.title}
      subTitle={props.subTitle}
      emailText={props.emailText}
      logo={props.logo}
      emailPlaceHolder={props.emailPlaceHolder}
      emailRequired={props.emailRequired}
      emailError={props.emailError}
      emailHelperText={props.emailHelperText}
      labelButtonLogin={props.buttonText}
      passwordText={props.passwordText}
      passwordRequired={props.passwordRequired}
      passwordError={props.passwordError}
      passwordHelperText={props.passwordHelperText}
      codeText={props.codeText}
      codeRequired={props.codeRequired}
      codeHelperText={props.codeHelperText}
      btnColor="#fffff"
      userForm="ConfirmPasswordReset"
      onSignIn={props.onSaveData}
    />
  );
};
